import { googleEvents } from "@apriil-digital-oslo/rubics-gtm-events";

const dataLayer: any[] =
  //@ts-ignore
  typeof window !== "undefined" && Array.isArray(window.dataLayer)
    ? //@ts-ignore
      window.dataLayer
    : [];

export const tracker = googleEvents(dataLayer);
